export default {
  COUNTRY_RUSSIA_ID: '38fd9f56-3d36-c426-ba9c-cf62884fcc4e',
};
